import { Translate } from '$common';



const questionTypeGroupMap = [
  {
    group_name: Translate.get('text'),
    types : [
      { type: 'text', type_name: Translate.get('text') },
      { type: 'number', type_name: Translate.get('number') },
      { type: 'textarea', type_name: Translate.get('paragraph') },
      { type: 'email', type_name: Translate.get('email') },
      { type: 'phone_number', type_name: Translate.get('phone') },
      { type: 'date', type_name: Translate.get('date') },
      { type: 'date_time', type_name: Translate.get('date_time') },
      { type: 'information', type_name: Translate.get('information') }
    ]
  },
  {
    group_name: Translate.get('selection'),
    types : [
      { type: 'checkbox', type_name: Translate.get('multiple_choice') },
      { type: 'radio', type_name: Translate.get('single_choice') },
      { type: 'dropdown', type_name: Translate.get('dropdown') },
      { type: 'range', type_name: Translate.get('range') },
      { type: 'tag', type_name: Translate.get('tag_list') },
      { type: 'yes_no', type_name: Translate.get('yes_no') },
      { type: 'ordering', type_name: Translate.get('ordering') }
    ]
  },
  {
    group_name: Translate.get('media'),
    types : [
      { type: 'image_upload', type_name: Translate.get('image_upload') },
      { type: 'multiple_image_upload', type_name: Translate.get('multiple_image_upload') },
      { type: 'image_capture', type_name: Translate.get('image_capture') },
      { type: 'multiple_image_capture', type_name: Translate.get('multiple_image_capture') },
      { type: 'voice_record', type_name: Translate.get('voice_record') },
      { type: 'video_capture', type_name: Translate.get('video_capture') }
    ]
  },
  {
    group_name: Translate.get('location'),
    types : [
      { type: 'location_stamp', type_name: Translate.get('location_stamp') },
      { type: 'location_map', type_name: Translate.get('location_map') }
    ]
  },
];

export default questionTypeGroupMap;



// WEBPACK FOOTER //
// ./src/constants/task-form/question-type-group-map.js